import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIsolate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_122_2290",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_122_2290)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 21.5C11.8358 21.5 11.6801 21.4782 11.5328 21.4345C11.3853 21.391 11.2462 21.3308 11.1155 21.2538L4.38475 17.3635C4.10008 17.1993 3.8815 16.9808 3.729 16.7078C3.57633 16.4346 3.5 16.1371 3.5 15.8152V8.18475C3.5 7.86292 3.57633 7.56542 3.729 7.29225C3.8815 7.01925 4.10008 6.80067 4.38475 6.6365L11.1155 2.74625C11.2462 2.66925 11.3853 2.609 11.5328 2.5655C11.6801 2.52183 11.8358 2.5 12 2.5C12.1577 2.5 12.3103 2.52183 12.4578 2.5655C12.6051 2.609 12.7473 2.66925 12.8845 2.74625L19.6152 6.6365C19.8936 6.80067 20.1106 7.01925 20.2663 7.29225C20.4221 7.56542 20.5 7.86292 20.5 8.18475V15.8152C20.5 16.1371 20.4221 16.4346 20.2663 16.7078C20.1106 16.9808 19.8936 17.1993 19.6152 17.3635L12.8845 21.2538C12.7473 21.3308 12.6051 21.391 12.4578 21.4345C12.3103 21.4782 12.1577 21.5 12 21.5ZM8.3365 15.673V12.75H5V15.7962C5 15.8474 5.01283 15.8955 5.0385 15.9405C5.06417 15.9853 5.10258 16.0238 5.15375 16.0557L11.25 19.6077V15.673H8.3365ZM8.3365 8.327H11.25V4.39225L5.15375 7.94425C5.10258 7.97625 5.06417 8.01467 5.0385 8.0595C5.01283 8.1045 5 8.15258 5 8.20375V11.25H8.3365V8.327ZM9.8365 14.173H14.1538V9.8365H9.8365V14.173ZM15.6538 15.673H12.75V19.6077L18.8462 16.0557C18.8974 16.0238 18.9358 15.9853 18.9615 15.9405C18.9872 15.8955 19 15.8474 19 15.7962V12.75H15.6538V15.673ZM15.6538 8.327V11.25H19V8.20375C19 8.15258 18.9872 8.1045 18.9615 8.0595C18.9358 8.01467 18.8974 7.97625 18.8462 7.94425L12.75 4.39225V8.327H15.6538Z",
			fill: "currentColor"
		})
	})]
});
export default SvgIsolate;
